<div class="freight-modal">
  <div mat-dialog-title>
    <div
      fxLayout="row nowrap"
      [fxLayoutAlign]="data?.title ? 'space-between end' : 'end end'">
      <span *ngIf="data?.title" class="freight-modal__title" >{{ data?.title | translate }}</span>
      <a (click)="closeDialog()"
         test-target="energy-labels-image-close"
         class="freight-modal__close">
        <mm-icon name="close">
        </mm-icon>
      </a>
    </div>
  </div>
  <div class="freight-modal__content" fxLayoutAlign="center center" mat-dialog-content>
    <img test-target="energy-labels-image" [src]="data?.src"/>
  </div>
</div>
